import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import './modal_component.scss'

export default class Modal extends React.Component {
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.flag === true) {
      document.body.classList.add('scroll-lock')
    } else if (this.props.flag === true) {
      document.body.classList.remove('scroll-lock')
      ReactDOM.findDOMNode(this).scrollTop = 0
    }
  }

  onClickOverlay(e) {
    if (e.target === ReactDOM.findDOMNode(this.refs.overlay)) {
      if (this.props.closeOverlayClicked && this.props.handleClose) {
        this.props.handleClose()
      }
    }
  }

  render(){
    return(
      <div styleName={`modal_overlay${this.props.overlayColor ? ` ${this.props.overlayColor}` : ''}${this.props.flag ? ' active' : ''}`} onClick={this.onClickOverlay.bind(this)} ref="overlay">
        {this.props.children}
      </div>
    )
  }
}

Modal.propTypes = {
  flag: PropTypes.bool.isRequired,
  handleClose: PropTypes.func,
  closeOverlayClicked: PropTypes.bool,
  overlayColor: PropTypes.string
}

Modal.defaultProps = {
  closeOverlayClicked: false
}
